import './style.scss'
import debounce from 'lodash.debounce'
import Fuse from 'fuse.js'
import { mapState, mapGetters } from 'vuex'
import verifyLeadingSlashLang from 'util/verifyLeadingSlashLang'

export default {
  name: 'Search',
  props: ['list'],
  computed: {
    ...mapGetters(['getParentsById', 'getStringTranslation', 'lang']),
    ...mapState({
      searchQuery: state => state.ui.searchQuery
    }),
    fuse () {
      const options = {
        shouldSort: true,
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        includeScore: true,
        includeMatches: true,
        threshold: 0.1,
        location: 0,
        distance: 1000,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: [
          {
            name: 'title',
            weight: 0.4
          },
          {
            name: 'titleOverride',
            weight: 0.4
          },
          {
            name: 'content',
            weight: 0.2
          }
        ]
      }
      const fuse = new Fuse(this.pagesFlattened, options)
      // this.log(this.pagesFlattened)
      return fuse
    },
    pagesFlattened () {
      return this.list.map((p) => {
        const content = (p.c_flex_content || []).map(c => {
          var string = ''
          if (c.rich_text) string += c.rich_text + ' '

          if (c.acf_fc_layout === 'downloads_list') {
            string += c.downloads_section.reduce((acc, i) => acc + ' ' + i.title + ' ' + i.download_links.reduce((acc, i) => acc + i.title + ' ' + i.file_link + ' ' || '', '') || '', '') + ' '
          }

          if (c.acf_fc_layout === 'content_list') {
            string += c.list_sections.reduce((acc, i) => acc + ' ' + i.section_title + i.list_items.reduce((acc, i) => acc + i.content + ' ' + i.title + ' ' || '', '') || '', '')
          }

          return string.replace(/<\/?[^>]+(>|$)/g, '') // strips html tags
        })
        return {
          title: p.title.rendered,
          titleOverride: p.page_title_override,
          link: p.link,
          id: p.id,
          uri: p.uri,
          content: content.filter(String).join(' ')
        }
      })
    }
  },
  methods: {
    getTranslation (translationTitle) {
      return this.getStringTranslation(translationTitle)
    },
    search (event) {
      this.hasSearched = true
      const searchQery = event.target ? event.target.value : event
      let result = this.fuse.search(searchQery)
      if (searchQery.length === 0) {
        result = []
      }
      this.fuseList = result
      // this.log(result)
      this.searchValue = searchQery
      this.$store.dispatch('saveSearchQuery', searchQery)
    }
  },
  data: () => ({
    searchValue: '',
    fuseList: [],
    score: 0.6,
    hasSearched: false
  }),
  mounted () {
    this.searchQuery ? this.search(this.searchQuery) : null
  },
  render (h) {
    const { lang } = this
    return (
      <div class='Search'>
        <div class='Search__inputContainer'>
          <input class='Search__inputSearch' value={this.searchValue} tabIndex='0' placeholder={this.getTranslation('search')} on-input={debounce(this.search, 250)}/>
          <img class='Search__inputIcon' src='/imgs/searchIcon.svg' alt='searchIcon' />
        </div>
        <ul class='Search__list'>
        <h3 class='Search__resultText'>
          { this.fuseList.length && this.fuseList.find(i => i.score <= this.score)
            ? (this.getTranslation('searchresults') + (' «' + this.searchValue + '»'))
            : this.searchValue && this.hasSearched
              ? this.getTranslation('nosearchresults') + (' «' + this.searchValue + '»')
              : null
          }
        </h3>
        { this.fuseList.map((i, index) => {
          if (i.score <= this.score) {
            return (
              <li class='Search__listItem'>
                <router-link to={verifyLeadingSlashLang(i.item.uri, lang)} class={'Search__listTitle'}>
                  {i.item.title}
                </router-link>
                <p class='Search__listTeaser'>
                  {(i.item.content ? i.item.content.substring(0, 125) : '') + (i.item.content && i.item.content.length > 125 ? '...' : '')}
                </p>
                <router-link to={verifyLeadingSlashLang(i.item.uri, lang)} class={'Search__listLink'}>
                  { this.getParentsById(i.item.id).map(i => {
                    return (
                      <span class='Search__listLinkItem'>{i.title.rendered}</span>
                    )
                  })}
                </router-link>
              </li>
            )
          }
        })}
        </ul>
      </div>
    )
  }
}

// <a class='Search__listLink' href={item.item.link} target='_blank'>{item.item.link}</a>



// WEBPACK FOOTER //
// ./client/components/Search/index.js